var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pill",class:_vm.classNames,on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._t("default"),(_vm.$listeners.remove)?_c('Icon',{attrs:{"name":"times"},on:{"click":function($event){return _vm.$emit('remove', $event)}}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }